// src/main.tsx: styles, then boot (tenant and me in parallel, then the theme) and render the app (spec 2.7).
// Style order: tokens, base, the shared primitives, then the design direction, which may restyle any of them, then
// the phone system (below 768px), which restyles the direction for phones, then the installed app's safe areas.
// Screen styles (prospect.css, team.css, auth.css) are imported by their own screens.
// The installed app (docs/DECISIONS.md, "Installable app"): <html data-display> is set before the first render, and
// after boot the service worker registers, or with PWA_MODE off every installed one is removed (src/lib/pwa.ts).
// The install prompt ("Install prompt"): how the page was opened is read before the router can drop ?src=app, and
// after boot src/pwa/prompt.ts records a launch of the app and watches for the household's visits and installs.
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/ui.css";
import "./styles/direction.css";
import "./styles/phone.css";
import "./styles/app.css";
import { render } from "preact";
import { App } from "./app/App";
import { markDisplay, startPwa } from "./lib/pwa";
import { launchOf } from "./pwa/install";
import { startInstall } from "./pwa/prompt";
import { QuoteScreen } from "./quote/QuoteScreen";
import { ReviewScreen } from "./review/ReviewScreen";
import { ConfirmScreen } from "./signup/ConfirmScreen";
import { boot, site } from "./state/session";

const root = document.getElementById("app");
// The sign-up confirm page (docs/DECISIONS.md "Builder sign-up") opens on a host with no builder, so it renders before, and
// without, the tenant boot below. The quote page and the owner's review are the same.
const platformPath = window.location.pathname.replace(/\/+$/, "");
if (root && platformPath === "/signup/confirm") {
  render(<ConfirmScreen />, root);
} else if (root && platformPath === "/quote") {
  // The quote page (docs/DECISIONS.md "The quote page (owner, 2026-10-25)"): the same host and no tenant.
  render(<QuoteScreen />, root);
} else if (root && platformPath === "/review") {
  // The owner's review of a builder (docs/DECISIONS.md "Builder setup: approval and going live"): the same host, no tenant.
  render(<ReviewScreen />, root);
} else if (root) {
  const launch = launchOf(window.location.search, markDisplay() === "app");
  render(<App />, root);
  void boot().then(() => {
    if (!site.value) return;
    void startPwa(site.value.pwa);
    startInstall(site.value.pwa, { launch });
  });
}
